import * as React from 'react'
import logo from '../../theme/logo-animation.svg'
import styled from 'styled-components'

const Logo = styled.img`
    width: 58px;
    height: 58px;
    margin:6em 0;
`
export default () => <Logo alt="Please wait..." src={logo} />